(function () {
  var FORM_SELECTOR = 'form[data-cf-form="L3t9bm"]';
  var ORDER_NUMBER_SELECTOR = 'input[data-cf-column-key="order_number"]';
  var PHOTO_COLUMN_KEYS = ['photo_1', 'photo_2', 'photo_3', 'photo_4', 'photo_5'];
  var SAFETY_MS = 20000;
  var HYDRATION_MS = 6500;
  var EMPTY_SETTLE_MS = 2500;
  var POLL_MS = 100;
  var observer;
  var safetyId;
  var checkId;
  var readyAt;
  var emptySince;
  var savedPhotoSeen = false;
  var finished = false;

  function revealForm() {
    document.body.classList.remove('job-report-form-pending');
  }

  function finish() {
    if (finished) return;

    finished = true;
    if (observer) observer.disconnect();
    if (safetyId) clearTimeout(safetyId);
    if (checkId) clearTimeout(checkId);
    revealForm();
  }

  function scheduleCheck(delay) {
    if (finished || checkId) return;

    checkId = setTimeout(function () {
      checkId = null;
      checkForm();
    }, delay);
  }

  function setInputValue(input, value) {
    var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

    if (descriptor && descriptor.set) {
      descriptor.set.call(input, value);
    } else {
      input.value = value;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getPhotoInputs(form) {
    return PHOTO_COLUMN_KEYS.map(function (columnKey) {
      return form.querySelector('input[type="file"][data-cf-column-key="' + columnKey + '"]');
    }).filter(Boolean);
  }

  function getRemoveButton(photoInput) {
    var fileField = photoInput.closest('.cf-field[data-cf-field-type="file"]');

    if (!fileField) return null;

    return fileField.querySelector(
      '.cf-file-preview button.cf-remove[aria-label="Remove file"]'
    );
  }

  function getReadyForm() {
    var form = document.querySelector(FORM_SELECTOR);

    if (
      !form ||
      form.getAttribute('data-cf-state') !== 'ready' ||
      !form.querySelector(ORDER_NUMBER_SELECTOR) ||
      getPhotoInputs(form).length !== PHOTO_COLUMN_KEYS.length
    ) {
      return null;
    }

    return form;
  }

  function checkForm() {
    if (finished) return;

    var form = getReadyForm();
    if (!form) {
      scheduleCheck(POLL_MS);
      return;
    }

    var now = Date.now();
    if (!readyAt) readyAt = now;

    var orderNumberInput = form.querySelector(ORDER_NUMBER_SELECTOR);
    var removeButton = getPhotoInputs(form)
      .map(getRemoveButton)
      .find(Boolean);
    var resetPerformed = false;

    if (orderNumberInput.value !== '') {
      setInputValue(orderNumberInput, '');
      resetPerformed = true;
    }

    if (removeButton) {
      // Remove one preview per pass because Helium may re-render after each click.
      // Helium renders this button without a type, so the browser otherwise treats it
      // as a submit button and validates every required field during the initial reset.
      removeButton.type = 'button';
      savedPhotoSeen = true;
      removeButton.click();
      resetPerformed = true;
    }

    if (resetPerformed) {
      emptySince = null;
      scheduleCheck(POLL_MS);
      return;
    }

    if (!emptySince) emptySince = now;

    // "ready" can be set before Helium finishes hydrating saved customer values.
    // Keep checking the hidden form for a bounded period before exposing it.
    if (
      (savedPhotoSeen || now - readyAt >= HYDRATION_MS) &&
      now - emptySince >= EMPTY_SETTLE_MS
    ) {
      finish();
      return;
    }

    scheduleCheck(POLL_MS);
  }

  function run() {
    safetyId = setTimeout(finish, SAFETY_MS);

    observer = new MutationObserver(function () {
      scheduleCheck(0);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cf-state'],
    });

    scheduleCheck(0);
  }

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run);
  }
})();
